import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import reducer from './reducers';

// AUTH
import { authentication } from '../services/authentication';
import { curriculums } from '../services/curriculums';
import { email } from '../services/email';
import { eventLogs } from '../services/eventLogs';
import { languages } from '../services/languages';
import { lessons } from '../services/lessons';
import { payment } from '../services/payment';
import { permission } from '../services/permission';
import { products } from '../services/products';
import { productEvents } from '../services/productEvents';
import { profile } from '../services/profile';
import { response } from '../services/response';
import { questionnaire } from '../services/questionnaire';
import { seoContent } from '../services/seoContent';
import { signedUrl } from '../services/signedUrl';
import { channels } from '../services/channels';
import { participants } from '../services/participants';
import { users } from '../services/users';
import { topic } from '../services/topic';
import { subject } from '../services/subject';

export const store: any = configureStore({
  reducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      // AUTH
      authentication.middleware,
      curriculums.middleware,
      email.middleware,
      eventLogs.middleware,
      languages.middleware,
      lessons.middleware,
      payment.middleware,
      permission.middleware,
      products.middleware,
      productEvents.middleware,
      profile.middleware,
      response.middleware,
      questionnaire.middleware,
      seoContent.middleware,
      signedUrl.middleware,
      channels.middleware,
      participants.middleware,
      users.middleware,
      topic.middleware,
      subject.middleware,
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
